import React, { useState, useEffect } from 'react'
import { BsInfoCircle, BsArrowCounterclockwise, BsCheck } from 'react-icons/bs'
import 'bootstrap/dist/css/bootstrap.min.css'
import apinode from '../../services/apinode'
import { format } from 'date-fns'
import Table from 'react-bootstrap/Table'
import { Modal, Card, Button } from 'react-bootstrap'
import { BsSave } from 'react-icons/bs'
import Navbar from '../../components/navbar/navbar'
import swal from 'sweetalert'
import { Spinner } from 'react-bootstrap'

const OrderList = () => {
  const [orders, setOrders] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [selectedOrderId, setSelectedOrderId] = useState(null)
  const [listItens, setListaItens] = useState([])
  const [quantidadeDev, setQuantidadeDev] = useState(0)
  const [pesquisa, setPesquisa] = useState('')
  const [pedidoSelect, setSelectpedido] = useState('')
  const [clienteSelect, setSelectCliente] = useState('')
  const [loading, setLoading] = useState(false)

  const handleFinalizar = async (id) => {
    try {
      console.log(id)
      const response = await apinode.put(
        `devolucoes/${id}/${localStorage.idconta}`,
      )

      if (response.status === 200) {
        swal('Sucesso', 'devolução finalizada com sucesso!', 'success')
        setShowModal(false)
      } else {
        console.warn('Código de status inesperado:', response.status)
        swal('Erro', 'Erro ao finalizar devolução.', 'error')
      }
    } catch (error) {
      console.error('Erro ao buscar/devolver devoluções:', error)
      swal('Erro', 'Erro ao finalizar devolução.', 'error')
    }
  }

  const handleQuantidadeDevChange = (event, itemId) => {
    const novaQuantidade = parseInt(event.target.value, 10)
    // Update the quantidadeDev state
    setQuantidadeDev(novaQuantidade)

    // Update the listItens state with the new quantity for the specific item
    const novoListItens = listItens.map((item) =>
      item.ID === itemId ? { ...item, QTD_DEV: novaQuantidade } : item,
    )
    // Set the updated listItens state
    setListaItens(novoListItens)
    console.log(novoListItens)
  }

  const handleAtualizaItens = async () => {
    try {
      setLoading(true)
      // Filtra os itens que têm DEVOLVIDO igual a 'D'
      const itensADevolver = listItens.filter((item) => item.DEVOLVIDO === 'D')
      // Verifica se há algum valor inválido nos itens a devolver
      const hasInvalidValues = itensADevolver.some(
        (item) =>
          item.QTD_DEV === null || item.QTD_DEV < 0 || item.QTD_DEV > item.QTD,
      )
      if (hasInvalidValues) {
        swal(
          'Erro',
          'Por favor, preencha a quantidade a devolver para todos os itens.',
          'error',
        )
        setLoading(false)
        return
      }

      // Se não houver valores inválidos, proceda com a requisição
      const response = await apinode.put(
        `devolucoes/${localStorage.idconta}`,
        itensADevolver,
      )

      if (response.status === 200) {
        swal(
          'Sucesso',
          'Atualizações de estoque foram incluídas na fila de processamento!',
          'success',
        )
        setLoading(false)
      } else {
        console.warn('Código de status inesperado:', response.status)
      }
    } catch (error) {
      console.error('Erro ao buscar/devolver devoluções:', error)
      setLoading(false)

      if (error.response) {
        console.error('Resposta da API com status:', error.response.status)
        setLoading(false)
      } else if (error.request) {
        console.error('Requisição feita, mas sem resposta recebida')
        setLoading(false)
      } else {
        console.error(
          'Erro durante a configuração da requisição',
          error.message,
        )
        setLoading(false)
      }
    }
  }

  const handleCheckboxChange = (itemId) => {
    // Encontrar o índice do objeto com base no ID
    const itemIndex = listItens.findIndex((item) => item.ID === itemId)

    // Verificar se o item foi encontrado
    if (itemIndex !== -1) {
      // Clonar o objeto para evitar mutações diretas no estado
      const updatedItem = { ...listItens[itemIndex] }

      // Alternar entre 'D' e 'N' para a propriedade 'status'
      updatedItem.DEVOLVIDO = updatedItem.DEVOLVIDO === 'D' ? 'N' : 'D'

      // Alternar a propriedade 'isSelected'
      updatedItem.isSelected = !updatedItem.isSelected

      // Atualizar o array com o objeto modificado
      const updatedListaItens = [
        ...listItens.slice(0, itemIndex),
        updatedItem,
        ...listItens.slice(itemIndex + 1),
      ]
      // Atualizar o estado com a nova lista de itens
      setListaItens(updatedListaItens)
      console.log(updatedListaItens)
    } else {
      console.error(`Item com ID ${itemId} não encontrado.`)
    }
  }

  const handleClose = () => setShowModal(false)
  const handleShow = () => setShowModal(true)

  const openDetailsModal = (orderId, orderPedido, orderCliente) => {
    setShowModal(true)
    setSelectedOrderId(orderId)
    BuscarItens(orderId)
    setSelectpedido(orderPedido)
    setSelectCliente(orderCliente)
  }

  const formatQuantity = (quantity) => {
    // Aqui você pode adicionar lógica para formatar a quantidade conforme desejado
    // Por exemplo, adicionar separadores de milhares ou decimais, etc.
    return new Intl.NumberFormat().format(parseFloat(quantity).toFixed(2))
  }

  const getStatusBadgeClassStatus = (status) => {
    return status === 'S' ? 'badge bg-success' : 'badge bg-warning'
  }

  const getStatusLabel = (status) => {
    return status === 'S' ? 'Concluído' : 'Pendente'
  }

  const BuscarDev = async () => {
    try {
      const response = await apinode.get(
        `devolucoes/search/${pesquisa}/${localStorage.idconta}`,
      )
      if (response.status === 200) {
        const data = response.data
        setOrders(data)
      }
    } catch (error) {
      console.error('Erro ao buscar devoluções:', error)
    }
  }

  const BuscarDevolucoes = async () => {
    try {
      const response = await apinode.get(`devolucoes/${localStorage.idconta}`)
      if (response.status === 200) {
        const data = response.data
        setOrders(data)
      }
    } catch (error) {
      console.error('Erro ao buscar devoluções:', error)
    }
  }

  const BuscarItens = async (id) => {
    try {
      const response = await apinode.get(
        `devolucoes/${id}/${localStorage.idconta}`,
      )
      if (response.status === 200) {
        const data = response.data
        console.log(data)
        setListaItens(data)
      }
    } catch (error) {
      console.error('Erro ao buscar itens:', error)
    }
  }

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'Aberto':
        return 'badge bg-primary'
      case 'Concluído':
        return 'badge bg-success'
      case 'Atrasado':
        return 'badge bg-danger'
      default:
        return 'badge bg-secondary'
    }
  }

  useEffect(() => {
    BuscarDevolucoes()
  }, [])

  return (
    <>
      <Navbar />

      <div className="mb-2 p-4 mt-page">
        <h2>Lista de Pedidos a Serem Devolvidos</h2>
        <div className="row">
          <div className="col-md-5">
            <div className="input-group mb-3">
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Pesquisar cliente, pedido ou ID Marktplace"
                aria-label="Pesquisar cliente, pedido ou ID Marktplace"
                aria-describedby="Pesquisar"
                value={pesquisa}
                onChange={(e) => setPesquisa(e.target.value)}
              />
              <button
                className="btn btn-success"
                type="button"
                id="Pesquisar"
                onClick={BuscarDev}
              >
                <i className="bi bi-search"></i> Pesquisar
              </button>
            </div>
          </div>
        </div>
        <Table
          bordered
          hover
          responsive
          className="nowrap"
        >
          <thead>
            <tr>
              <th>Pedido</th>
              <th>Nome</th>
              <th>ID Ped. Loja</th>
              <th>Marketplace</th>
              <th>Data</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.ID_PEDIDO}>
                <td>{order.ID_PEDIDO}</td>
                <td>{order.CLIENTE}</td>
                <td>{order.IDPEDIDOLOJA}</td>
                <td>{order.ID_LOJA}</td>
                <td>{format(new Date(order.DATA), 'dd/MM/yyyy')}</td>
                <td>
                  <span className={getStatusBadgeClass(order.STATUS)}>
                    {order.STATUS}
                  </span>
                </td>
                <td>
                  {/* Adicione ícones aos botões com títulos */}
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-primary btn-sm"
                      title="Detalhes"
                      onClick={() =>
                        openDetailsModal(
                          order.ID,
                          order.ID_PEDIDO,
                          order.CLIENTE,
                        )
                      }
                    >
                      <BsInfoCircle />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <Modal
          show={showModal}
          onHide={handleClose}
          dialogClassName="custom-modalzpl"
        >
          <Modal.Header
            closeButton
            className="text-dark"
          >
            <Modal.Title>
              <h4
                style={{
                  fontFamily: 'arial',
                  margin: '0',
                  fontSize: '28px',
                  fontWeight: 'bold',
                }}
              >
                Lista de Itens
              </h4>
              <div style={{ fontSize: '18px', marginTop: '5px' }}>
                Pedido: {pedidoSelect} | Cliente: {clienteSelect}
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {listItens.map((item) => (
              <Card
                key={item.ID}
                style={{
                  marginBottom: '10px',
                  opacity: item.DEVOLVIDO === 'S' ? 0.5 : 1, // Define a opacidade para indicar que o card está desativado
                  pointerEvents: item.DEVOLVIDO === 'S' ? 'none' : 'auto', // Desativa eventos de ponteiro se o card estiver desativado
                }}
                disabled={item.DEVOLVIDO === 'S'} // Adiciona a propriedade disabled para desativar o card
              >
                <Card.Body>
                  <Card.Title>{item.DESCRICAO}</Card.Title>
                  <Card.Text>
                    <strong>SKU:</strong> {item.SKU} <br />
                    <span className="d-flex align-items-center">
                      <strong>Quantidade:</strong>
                      <span className="badge bg-primary ms-2">
                        {formatQuantity(item.QTD)}
                      </span>
                      <span
                        className={`badge ms-2 ${getStatusBadgeClassStatus(
                          item.DEVOLVIDO,
                        )}`}
                      >
                        {item.DEVOLVIDO === 'S'
                          ? 'Devolvido'
                          : item.DEVOLVIDO === 'N'
                            ? 'Pendente'
                            : 'Em Processo'}
                      </span>
                      <input
                        type="checkbox"
                        className="ms-2"
                        checked={
                          item.isSelected || ['S', 'D'].includes(item.DEVOLVIDO)
                        }
                        onChange={() => handleCheckboxChange(item.ID)}
                      />
                      {['S', 'D'].includes(item.DEVOLVIDO) && (
                        <div
                          key={item.ID}
                          className="ms-2"
                        >
                          <input
                            type="number"
                            value={item.QTD_DEV || 0}
                            onChange={(e) =>
                              handleQuantidadeDevChange(e, item.ID)
                            }
                            className="ms-2 form-control"
                          />
                        </div>
                      )}
                    </span>
                  </Card.Text>
                </Card.Body>
              </Card>
            ))}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="success"
              onClick={() => handleFinalizar(pedidoSelect)}
            >
              <BsCheck className="me-2" />
              Finalizar
            </Button>

            <Button
              variant="primary"
              onClick={handleAtualizaItens}
            >
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Carregando...
                </>
              ) : (
                <>
                  <BsSave className="me-2" />
                  Devolver Produto
                </>
              )}
            </Button>

            <Button
              variant="secondary"
              onClick={handleClose}
            >
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}

export default OrderList
